import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./EditDesiredType.css";
import { getDesiredById, updateDesiredApi } from "../../../../services/DesiredType/DesiredType.service";
import { toast } from "react-toastify";

const EditDesiredType: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchDesired = async () => {
      if (!id) return;
      try {
        const numericId = parseInt(id, 10);
        const data = await getDesiredById(numericId);
        setName(data?.name ?? "");
        setDescription(data?.description ?? "");
      } catch (error) {
        console.error("Error fetching Desired Type:", error);
        toast.error("Failed to load Desired Type");
      } finally {
        setLoading(false);
      }
    };

    fetchDesired();
  }, [id]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!id) return;
    if (!name.trim()) {
      toast.error("Name is required");
      return;
    }

    try {
      setSubmitting(true);
      const numericId = parseInt(id, 10);
      const payload = { name: name.trim(), description: description.trim() };

      await updateDesiredApi(numericId, payload);
      toast.success("Desired Type updated successfully");
      navigate("/desired-type/list");
    } catch (error) {
      console.error("Error updating Desired Type:", error);
      toast.error("Failed to update Desired Type");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="desired-edit-overlay">
      <div className="desired-edit-card">
        <h2>Edit Desired Type</h2>
        <form onSubmit={handleSubmit}>
          <label>Name *</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Name"
          />
          <label>Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Description"
            rows={4}
          />

          <div className="button-close">
            <button type="button" onClick={() => navigate("/desired-type/list")}>
              Close
            </button>
            <button type="submit" disabled={submitting}>
              {submitting ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditDesiredType;
